import React from 'react';
import styled from '@emotion/styled';
import { Aside } from '../../blocks/FlexLayout';
import OneTapSwipeOfferTopNav from './oneTapSwipeOffer/components/OneTapSwipeOfferTopNav';
import breakpoints from '../../../theme/material/breakpoints';
import { GridView, ListView } from '../../../atoms/icons/favoriteIcons';
import TopNav from '../../blocks/TopNav';
import { areEqual, isDarkMode } from '../../../utils/helpers';

interface IOfferTopNavProps {
  isOneTapModeVariation: boolean;
  subRoutes: any[];
  handleViewSwitcher: () => void;
  viewType: string;
  themeDarkMode?: boolean;
}

const ViewActions = styled('a')({
  cursor: 'pointer',
  marginRight: 15,
  height: 22,
  width: 22,
  [breakpoints.down('sm')]: {
    marginRight: 15,
  },
});

const OfferTopNav: React.FC<IOfferTopNavProps> = ({
  isOneTapModeVariation,
  subRoutes,
  handleViewSwitcher,
  viewType,
}: IOfferTopNavProps) => {
  return (
    <Aside className="offers--menu-wrap">
      {isOneTapModeVariation ? (
        <OneTapSwipeOfferTopNav
          className="offers-sub-nav"
          subRoutes={subRoutes}
          customItem={
            <ViewActions
              data-test-id="list-grid-view-btn"
              onClick={() => handleViewSwitcher()}
              aria-label={viewType === 'list' ? 'List' : 'Grid'}
              style={{ marginRight: 9 }}
            >
              {viewType === 'list' ? <GridView /> : <ListView />}
            </ViewActions>
          }
          themeDarkMode={isDarkMode()}
        />
      ) : (
        <TopNav className="offers-sub-nav" subRoutes={subRoutes} themeDarkMode={isDarkMode()} />
      )}
    </Aside>
  );
};

export default React.memo(OfferTopNav, areEqual);
